import styled from "styled-components";
import * as COLORS from './colors';
export const LIST = styled.ul`
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
    flex-flow: column;
`;

export const LABEL = styled.span`
    font-size: 12px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.25;
    letter-spacing: 1px;
`;

export const LABEL_HEADER = styled(LABEL)`
    font-size: 14px;
`;

export const LABEL_TITLE = styled.span`
    font-size: 17px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.12;
    letter-spacing: 1.2px;
}
`;

export const BUTTON = styled.button`
    border: none;
    outline: none;
    cursor: pointer;
`;

export const BUTTON_ACTION = styled(BUTTON)`
    display: flex;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.5;
    letter-spacing: 1.7px;
    text-align: center;
    border-radius: 1px;
    align-items: center;
`;

export const INPUT = styled.input`
    outline: none;
    display: flex;
    padding: none;
    border: none;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 1.5px;
    font-size: 14px;
    :read-only { 
        color: ${COLORS.INPUT_READONLY};
        cursor: not-allowed 
    };
`;
